<template>
  <div class="overview">
    <div class="overview__course-info-wrapper">
      <div class="overview__branding-wrapper">
        <h6 v-if="course.vendor" class="overview__branding content-type">
          {{ course.vendor.name }}
        </h6>
        <h6 v-else class="overview__branding content-type">
          INE
        </h6>
        <h6
          v-if="course.status === 'coming soon'"
          class="overview__coming-soon"
        >
          Coming Soon
        </h6>
        <div
          v-if="isAuthenticated && course.under_construction"
          class="overview__refactor-undergoing__wrapper"
        >
          <h6 class="overview__refactor-undergoing">
            Refactor undergoing
          </h6>
          <i
            class="material-icons info-icon"
            role="presentation"
            v-tooltip="{
              content: `We're working to improve this course. You can expect some changes in the next few weeks`,
              placement: 'right-center',
            }"
          >
            info_outline
          </i>
        </div>
      </div>
      <h4 itemprop="courseCode" class="overview__title content-title">
        {{ course.name }}
      </h4>
      <div class="overview__description-wrapper">
        <p
          itemprop="about"
          v-html="course.description"
          class="overview__description content-description"
        ></p>
      </div>
      <div v-if="isAuthenticated" class="overview__actions">
        <Active :course="course" class="overview__activator" />
        <CourseFeedback
          v-if="course && course.status !== 'coming soon'"
          :course="course"
        />
      </div>
      <div v-if="isCtaShown" class="overview__cta">
        <SubscriptionRequired :plansLink="plansLink" />
      </div>
    </div>
    <div v-if="course.trailer_jwplayer_id" class="overview__video">
      <SampleVideo :videoId="course.trailer_jwplayer_id" />
    </div>
  </div>
</template>

<script>
import Active from '@/components/properties/Active.vue'
import SubscriptionRequired from '@/components/properties/SubscriptionRequired.vue'
import SampleVideo from '@/components/media/SampleVideo.vue'
import CourseFeedback from '@/components/course/CourseFeedback.vue'

export default {
  name: 'Overview',
  components: {
    Active,
    SubscriptionRequired,
    SampleVideo,
    CourseFeedback,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
  },
  computed: {
    isCtaShown() {
      return !this.isAuthenticated && this.course.status !== 'coming soon'
    },
  },
}
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 0 20px 0;
  @include tablet {
    padding: 0 0 75px 0;
  }
  &__course-info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding: 0;
    @include tablet {
      width: 50%;
      padding: 0 25px 0 0;
    }
    @include desktop {
      padding: 0 75px 0 0;
    }
    @include lg-desktop {
      padding: 0 100px 0 0;
    }
  }
  &__branding-wrapper {
    display: flex;
  }
  &__coming-soon,
  &__refactor-undergoing {
    margin: 0 0 0 15px;
    color: var(--white);
    background: var(--black);
    padding: 0 5px;
    font-size: 0.8rem;
    font-family: var(--font-bold);
    text-transform: uppercase;
    &__wrapper {
      display: flex;
      align-items: center;
      .info-icon {
        color: white;
        margin-left: 10px;
      }
    }
  }
  &__branding {
    margin: 0;
    font-family: var(--font-medium);
  }
  &__title {
    margin: 10px 0 30px 0;
    font-family: var(--font-bold);
    line-height: normal;
    letter-spacing: normal;
    @include mobile {
      letter-spacing: -1.04px;
      line-height: 2.7rem;
    }
  }
  &__description-wrapper {
    margin: 0 0 50px 0;
  }
  &__description {
    font-size: rem(14px);
    line-height: 20px;
    letter-spacing: -0.36px;
    white-space: pre-line;
    ::v-deep a {
      color: var(--light-blue-gray);
      text-decoration: underline;
      &:hover {
        color: var(--white);
      }
    }
  }
  &__bootcamp-related {
    color: var(--white);
    font-size: rem(12);
    line-height: 20px;
    font-style: italic;
    font-weight: 450;
    margin-top: 10px;
    a,
    a:visited {
      color: var(--white);
      text-decoration: underline;
    }
  }
  &__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    :global(.btn--secondary) {
      --btn-border-color: rgba(255, 255, 255, 0.7);
    }
  }
  &__activator {
    margin: 0 3px 0 0;
    @include mobile {
      margin: 0 20px 0 0;
      max-width: 125px;
    }
  }
  &__video {
    width: 100%;
    padding: 25px;
    margin: 25px 0 0 0;
    @include mobile {
      padding: 50px;
    }
    @include tablet {
      display: flex;
      align-items: center;
      padding: 0 0 0 25px;
      width: 50%;
    }
    @include desktop {
      margin: 0;
      padding: 0 0 0 75px;
    }
    @include lg-desktop {
      padding: 0 0 0 100px;
    }
  }
}
</style>
